import React from "react"
import HeroContent from "./hero-content"
import ScrollAnimation from "react-animate-on-scroll"
import HeroImgDesktop from "./our-story-img-desktop"
import HeroImgMobile from "./our-story-img-mobile"
import OurStoryPageStyle from "./our-story-page.module.scss"

const Hero = () => (
    <div className={OurStoryPageStyle.heroDiv}>
        <ScrollAnimation className="fadeIn" animateOnce={true} duration={2}>
            <HeroImgDesktop />
            <HeroImgMobile />
        </ScrollAnimation>
        <HeroContent />
    </div>
)

export default Hero